<template>
    <div id="integration-edit-popup">
        <ValidationObserver class="centerx default-input" ref="form" v-slot="{handleSubmit}">
            <div class="vx-row mb-4" v-if="popupType !== 'editTeamIntegrationWhenGroupedTeam'">
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                        vid="advertiser_selected"
                        :name="$t('label.Choose_advertiser')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-select
                            class="sm:mb-0 cursor-pointer"
                            :placeholder="$t('label.Choose_advertiser')"
                            @input="chooseAdvertiser"
                            v-model="popupFields.advertiser_selected"
                            :options="popupFields.advertisers_list"
                            :clearable="false"
                            :disabled="true"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                        vid="model"
                        :name="$t('modals.Choose_model')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-select
                            name="model"
                            class="sm:mb-0 cursor-pointer"
                            :placeholder="$t('modals.Choose_model')"
                            @input="chooseModel"
                            v-model="popupFields.model"
                            :options="popupFields.model_list" :disabled="popupFields.model_list.length === 0"
                            :clearable="false"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </div>
            <div class="vx-row mb-4" v-if="popupType !== 'editTeamIntegrationWhenGroupedTeam'">
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                        vid="geo"
                        :name="$t('modals.Choose_geo')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-select
                            class="sm:mb-0 cursor-pointer"
                            :placeholder="$t('modals.Choose_geo')"
                            @input="chooseGeo"
                            v-model="popupFields.geo"
                            :options="popupFields.geo_list"
                            :disabled="popupFields.geo_list.length === 0"
                            :clearable="false"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                        vid="integration"
                        :name="$t('label.Choose_integration')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-select
                            name="geo"
                            class="sm:mb-0 cursor-pointer"
                            :placeholder="$t('label.Choose_integration')"
                            @input="chooseIntegration"
                            v-model="popupFields.integration"
                            :options="popupFields.integration_list"
                            :disabled="popupFields.geo.length === 0"
                            :clearable="false"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </div>
            <vs-divider v-if="popupType === 'createTeamIntegrationWhenGroupedTeam'"></vs-divider>
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <v-select name="countries" class="sm:mb-0 cursor-pointer" multiple
                              :placeholder="$t('modals.Choose_countries')"
                              :closeOnSelect="false"
                              @input="changeCountryList" v-model="popupFields.countries"
                              :options="popupFields.countries_list"
                              :disabled="popupFields.countries_list && popupFields.countries_list.length === 0"
                              :clearable="false"/>
                </div>
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <v-select name="offers_accepted" id="offers_accepted" class="sm:mb-0 cursor-pointer" multiple
                              :placeholder="$t('modals.Choose_accepted_offers')"
                              @input="changeOfferList"
                              :closeOnSelect="false"
                              v-model="popupFields.offers_accepted"
                              :options="popupFields.offers_list"
                              :disabled="popupFields.offers_list && popupFields.offers_list.length === 0"
                              :clearable="false"/>
                </div>
            </div>
            <div class="flex pb-4 justify-end items-center globalAdd">
                <div class="flex items-center mr-4" v-if="activeGlobal">
                    <div class="mr-4 relative">
                        <p class="label">{{ $t('label.External_price') }}</p>
                        <vs-input class="width" v-model="external_price"/>
                    </div>
                    <div class="mr-4 relative">
                        <p class="label">{{ $t('label.Internal_price') }}</p>
                        <vs-input class="width" v-model="internal_price"/>
                    </div>
                    <div class="mr-4 relative">
                        <p class="label">{{ $t('label.percent') }}</p>
                        <vs-input class="width" :disabled="!guaranteeSwitch" v-model="percent"/>
                    </div>
                    <div class="mr-4 relative">
                        <p class="label">{{ $t('label.guarantee') }}</p>
                        <vs-switch color="success" v-model="guaranteeSwitch" icon-pack="feather" vs-icon-off="icon-x"
                                   vs-icon-on="icon-check"/>
                    </div>
                    <div>
                        <vs-button @click="globalAdd" color="primary" type="filled">{{ $t('buttons.Add') }}</vs-button>
                    </div>
                </div>
                <vs-button @click="activeGlobal = true" size="small" :disabled="activeGlobal" radius color="success"
                           type="flat" icon-pack="feather" icon="icon-plus"></vs-button>
            </div>
            <div>
                <vs-table :noDataText="$t('table.No_data_available')" :data="geosList">
                    <template slot="thead">
                        <vs-th>{{ $t('global.Country') }}</vs-th>
                        <vs-th>{{ $t('global.Offer') }}</vs-th>
                        <vs-th>{{ $t('label.External_price') }}</vs-th>
                        <vs-th>{{ $t('label.Internal_price') }}</vs-th>
                        <vs-th>{{ $t('label.percent') }}</vs-th>
                        <vs-th>{{ $t('label.guarantee') }}?</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>{{ tr.name }}</vs-td>
                            <vs-td class="relative">{{ tr.offer }}</vs-td>
                            <vs-td class="relative">
                                <vs-input :class="{'error': tr.validations && tr.validations.external_price}"
                                          class="inputx teamsIntInput" v-model="tr.external_price"
                                          @input="setPriceValidation(indextr, 'external_price')"/>
                                <vs-icon class="absolute val" v-if="tr.validations && tr.validations.external_price"
                                         v-tooltip="tr.validations.external_price" size="small" color="red"
                                         icon-pack="feather" icon="icon-alert-circle"></vs-icon>
                            </vs-td>
                            <vs-td class="relative">
                                <vs-input :class="{'error': tr.validations && tr.validations.internal_price}"
                                          class="inputx teamsIntInput" v-model="tr.internal_price"
                                          @input="setPriceValidation(indextr, 'internal_price')"/>
                                <vs-icon class="absolute val" v-if="tr.validations && tr.validations.internal_price"
                                         v-tooltip="tr.validations.internal_price" size="small" color="red"
                                         icon-pack="feather" icon="icon-alert-circle"></vs-icon>
                            </vs-td>
                            <vs-td class="relative">
                                <div>
                                    <vs-input :class="{'error': tr.validations && tr.validations.percent}"
                                              name="percent" class="inputx teamsIntInput" v-model="tr.percent"
                                              :disabled="!tr.guarantee" @input="percentValidation(indextr)"/>

                                    <vs-icon class="absolute val" v-if="tr.validations && tr.validations.percent"
                                             v-tooltip="tr.validations.percent" size="small" color="red"
                                             icon-pack="feather"
                                             icon="icon-alert-circle"></vs-icon>
                                </div>
                            </vs-td>
                            <vs-td>
                                <vs-switch @input="guarantee(indextr)" color="success" v-model="tr.guarantee"
                                           icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full ml-auto text-right">
                    <div class="mt-8 flex flex-wrap items-center justify-end">
                        <vs-button class="mr-3 mb-2" @click.prevent="handleSubmit(submitForm)">{{ $t('buttons.Save') }}</vs-button>
                    </div>
                </div>
            </div>
        </ValidationObserver >
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import vSelect from 'vue-select'
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    props: ['popupData', 'popupType', 'popupButton'],
    data() {
        return {
            popupFields: {
                advertisers_list: [],
                advertiser_selected: [],
                model: [],
                model_list: [],
                geo: [],
                geo_list: [],
                countries: [],
                countries_list: [],
                offers_accepted: [],
                offers_not_accepted: [],
                offers_list: [],
                offers_list_changed: [],
                integration: [],
                integration_list: []
            },
            submitButtonText: '',
            filtered: [],
            geosList: [],

            external_price: '',
            internal_price: '',
            percent: 0.00,
            guaranteeSwitch: false,

            validations: {
                external_price: '',
                internal_price: '',
                percent: ''
            },
            activeGlobal: false,

            options: {
                countries: [],
                offers: []
            }
        }
    },

    computed: {
        teamIntegration() {
            return this.$store.getters.teams_integrations
        }
    },

    watch: {
        'popupFields.countries'(value) {
            this.setGeoList('countries', value)
        },
        'popupFields.offers_accepted'(value) {
            this.setGeoList('offers', value)
        }
    },

    methods: {
        setGeoList(option, value) {
            this.options[option] = value
            if(this.options[option]) {
                this.geosList = this.geosMuttationList()
            }
        },
        globalAdd() {
            for(const index in this.geosList) {
                if(this.external_price) this.geosList[index].external_price = this.external_price
                if(this.internal_price) this.geosList[index].internal_price = this.internal_price
                if(this.percent) this.geosList[index].percent = this.percent
                this.geosList[index].guarantee = this.guaranteeSwitch
            }

            this.external_price = ''
            this.internal_price = ''
            this.percent = 0.00
            this.guaranteeSwitch = false
            this.activeGlobal = false
        },

        geosMuttationList() {
            const newElementList = (offer, name) => {
                return {
                    adv_teams_int_id: this.popupData.data ? this.popupData.data.id : null,
                    external_price: 0.00,
                    internal_price: 0.00,
                    percent: 0.00,
                    offer,
                    guarantee: false,
                    name,
                    validations: {
                        external_price: '',
                        internal_price: '',
                        percent: ''
                    }
                }
            }

            const arr = []
            for(const c of this.options.countries) {
                let result = null
                if(this.popupData.data && this.popupData.data.advertiser_integration_team_payment && this.popupData
                    .data.advertiser_integration_team_payment.length) {
                    result = this.popupData.data.advertiser_integration_team_payment.filter(el => el.name === c)
                }

                if(result && Array.isArray(result)) {
                    for(const list of this.options.offers) {
                        const is = result.find(item => item.offer === list)
                        if(is) {
                            arr.push({
                                ...is,
                                validations: {
                                    external_price: '',
                                    internal_price: '',
                                    percent: ''
                                }
                            })
                        } else {
                            arr.push(newElementList(list, c))
                        }
                    }
                } else {
                    for(const offer of this.options.offers) {
                        const list = newElementList(offer, c)

                        if(!list.adv_teams_int_id) delete list.adv_teams_int_id
                        arr.push(list)
                    }
                }
            }
            return arr
        },

        setPriceValidation(index, typePrice) {
            if(index) {
                if(this.geosList[index][typePrice] === '') {
                    this.geosList[index]['validations'][typePrice] = `${typePrice} is required`
                    return false
                }
                this.geosList[index]['validations'][typePrice] = ''
                return true
            }
        },

        percentValidation(index) {
            if(index) {
                if(this.geosList[index].percent === '') {
                    this.geosList[index]['validations']['percent'] = 'percent is required'
                    return false
                }

                if(!(/^[0-9][0-9]?$|^100$/.test(this.geosList[index].percent))) {
                    this.geosList[index]['validations']['percent'] = 'Incorrect value (0-100)%'
                    return false
                }

                this.geosList[index]['validations']['percent'] = ''
                return true
            }
        },

        guarantee(index) {
            if(!this.geosList[index].guarantee) {
                this.geosList[index]['validations']['percent'] = ''
            } else {
                this.percentValidation(index)
            }
        },

        checkC_Validation() {
            const arr = []
            for(const index in this.geosList) {
                const external_price = this.setPriceValidation(index, 'external_price')
                const internal_price = this.setPriceValidation(index, 'internal_price')
                const percent = this.percentValidation(index)

                if(!external_price || !internal_price || !percent) {
                    arr.push(false)
                }
            }

            if(arr.includes(false)) {
                return false
            }
            return true
        },

        submitForm() {
            const offers = Object.values(this.popupFields.offers_accepted),
                countries = Object.values(this.popupFields.countries),
                advIntData = {}
            advIntData.advTeamIntegration = {
                team_id: this.popupData.id,
                offers_accepted: offers,
                countries
            }

            let dispatchPath = '',
                dispatchData = {}
            if(this.popupType === 'createTeamIntegrationWhenGroupedTeam') {
                dispatchPath = 'create'
                advIntData.advTeamIntegration.advertiser_integration_id = this.popupFields.integration.value
                advIntData.advTeamIntegrationPayment = this.geosList

                dispatchData = {
                    url: this.$url.advrtsr_team_integration.create,
                    mutation: 'CREATE_TEAM_INTEGRATIONS',
                    data: advIntData
                }
            } else {
                dispatchPath = 'edit'
                this.popupData.data.advertiser_integration_id
                advIntData.advTeamIntegration.advertiser_integration_id = this.popupData.data.advertiser_integration_id



                advIntData.advTeamIntegrationPayment = this.geosList

                advIntData.advTeamIntegration.team_id = this.popupData.currentTeamId

                dispatchData = {
                    url: this.$url.advrtsr_team_integration.update,
                    mutation: 'EDIT_TEAM_INTEGRATIONS',
                    data: advIntData
                }
            }

            this.$store.dispatch(dispatchPath, dispatchData)
                .then(async(response) => {

                    await this.$store.dispatch('fetchId', {
                        url: this.$url.advrtsr_team_integration.get,
                        mutation: 'FETCH_TEAM_INTEGRATIONS',
                        id: this.popupType === 'createTeamIntegrationWhenGroupedTeam' ? this.popupData.id : this.popupData.currentTeamId
                    })

                    const dispatchPathTeam = 'fetch',
                        dispatchDataTeam = {
                            url: this.$url.settings_team.get,
                            mutation: 'SET_TEAMS'
                        }
                    await this.$store.dispatch(dispatchPathTeam, dispatchDataTeam)
                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                    EventBus.$emit('getGroupedTeamsByAdvertiser')
                }).catch(error => {
                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            })
        },
        chooseAdvertiser() {
            this.clearOptions([
                'model',
                'model_list',
                'geo',
                'geo_list',
                'integration',
                'integration_list',
                'countries',
                'countries_list',
                'offers_accepted',
                'offers_not_accepted',
                'offers_list'
            ])
            this.setModelsOrGeo('model', 'model_list', 'traffic_model')
        },

        chooseModel() {
            this.clearOptions([
                'geo',
                'geo_list',
                'integration',
                'integration_list',
                'countries',
                'countries_list',
                'offers_accepted',
                'offers_not_accepted',
                'offers_list'
            ])
            this.setModelsOrGeo('geo', 'geo_list', 'geo')
        },
        setModelsOrGeo(filtereProperty, popupFieldsProperty, valProperty) {
            this.popupFields.advertiser_selected.advertiser_integrations.forEach(val => {
                if(!this.filtered[filtereProperty].some(el => el === val[valProperty].name)) {
                    this.popupFields[popupFieldsProperty].push({
                        label: val[valProperty].name
                    })
                    this.filtered[filtereProperty].push(val[valProperty].name)
                }
            })
        },

        chooseGeo() {
            this.clearOptions([
                'integration',
                'integration_list',
                'countries',
                'countries_list',
                'offers_accepted',
                'offers_not_accepted',
                'offers_list'
            ])
            this.setIntegrations()
        },

        setIntegrations() {
            this.popupFields.advertiser_selected.advertiser_integrations.forEach((val, index) => {
                if(this.popupFields.geo.label === val.geo.name && this.popupFields.model.label === val.traffic_model.name) {
                    this.popupFields.integration_list.push({
                        label: val.name,
                        value: val.id,
                        arrId: index
                    })
                    this.filtered.integration.push(val.name)
                }
            })
        },

        chooseIntegration() {
            this.clearOptions([
                'countries',
                'countries_list',
                'offers_accepted',
                'offers_not_accepted',
                'offers_list'
            ])
            this.setCountries()
            this.setOffers()
        },
        setCountries(countries) {
            if(countries) {
                this.popupFields.countries_list = Object.values(countries[0])
                if (this.popupType === 'editTeamIntegrationWhenGroupedTeam') {
                    this.popupFields.countries = Object.values(countries[1])
                }
                this.changeCountryList()
            } else {
                this.popupFields.advertiser_selected.advertiser_integrations.forEach((val) => {
                    if(this.popupFields.integration.label === val.name) {
                        if (this.popupType === 'editTeamIntegrationWhenGroupedTeam') {
                            this.popupFields.countries = Object.values(val.integration_setting.countries)
                        }
                        this.popupFields.countries_list = Object.values(val.integration_setting.countries)
                    }
                })
            }
        },
        setOffers(offers) {
            if(offers) {
                this.popupFields.offers_list = Object.values(offers[0])
                if (this.popupType === 'editTeamIntegrationWhenGroupedTeam') {
                    this.popupFields.offers_accepted = Object.values(offers[1])
                }
                this.changeOfferList()
            } else {
                const integrationSettings = this.popupFields.advertiser_selected.advertiser_integrations[this
                    .popupFields.integration.arrId].integration_setting

                for(let i = 0; i < integrationSettings.offers_accepted.length; i++) {
                    this.popupFields.offers_list.push(integrationSettings.offers_accepted[i])
                    if (this.popupType === 'editTeamIntegrationWhenGroupedTeam') {
                        this.popupFields.offers_accepted.push(integrationSettings.offers_accepted[i])
                    }
                }
            }
        },
        changeCountryList() {
            this.popupFields.countries_list_changed = this.removeSelected(this.popupFields.countries_list, this
                .popupFields.countries)
        },
        changeOfferList() {
            this.popupFields.offers_list_changed = this.removeSelected(this.popupFields.offers_list, this
                .popupFields.offers_accepted)
        },
        removeSelected(list, selected) {
            const temp = []
            Object.assign(temp, list)
            selected.map((val2) => {
                return temp.map((val, index) => {
                    if((val === val2) && (val.value === undefined && typeof val.value ===
                        'undefined')) {
                        temp.splice(index, 1)
                    } else if(val.value === val2.value && (val.value !== undefined && typeof val
                        .value !== 'undefined')) {
                        temp.splice(index, 1)
                    }
                })
            })
            return temp
        },
        clearOptions(arr) {
            arr.map((val) => {
                this.popupFields[val] = []
                this.filtered[val] = []
            })
        }
    },
    async mounted() {
        this.submitButtonText = this.popupButton

        const dispatchPath = 'fetch',
            dispatchData = {
                url: this.$url.advrtsr.get,
                mutation: 'dataList/SET_PRODUCTS'
            }
        this.$store.dispatch(dispatchPath, dispatchData)
            .then(() => {
                const advertisers = this.$store.state.dataList.products

                if(this.popupType === 'editTeamIntegrationWhenGroupedTeam') {
                    const teamCurrentEditIntegration = this.popupData.data
                    Object.values(advertisers).forEach(val => {
                        Object.values(val.advertiser_integrations).forEach(val2 => {
                            const v3 = Object.values(val2.advertiser_team_integration).find(val3 => teamCurrentEditIntegration.id === val3.id)
                            if(v3) {
                                this.setOffers([val2.integration_setting.offers_accepted, v3.offers_accepted])
                                this.setCountries([val2.integration_setting.countries, v3.countries])
                            }
                        })

                    })
                } else {
                    advertisers.forEach((val) => {
                        if(val.is_active) {
                            const temp = val
                            temp.label = val.name
                            temp.value = val.id
                            this.popupFields.advertisers_list.push(temp)
                            if (this.popupData.defaultAdv && temp.value === this.popupData.defaultAdv){
                                this.popupFields.advertiser_selected = temp
                                this.chooseAdvertiser()
                            }
                        }
                    })

                }

                this.$store.commit('UPDATE_LOADER_STATE', false)
            })
            .catch(e => {
                this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
                new ErrorHandler(e).send
            })
    }
}

</script>
<style lang="scss">
.globalAdd {
    .width {
        width: 70px;
    }

    .label {
        color: gray;
        font-size: 10px;
    }
}

.teamsIntInput {
    width: auto !important;

    .vs-con-input {
        width: auto !important;
    }
}

.val {
    display: block;
    top: 0px;
    right: 0px;
    background: #fff;
}

.error {
    input {
        border: 1px solid red !important;
    }
}

#user-edit-popup {
    .vs-tabs--li button {
        font-size: 0.8rem;
        line-height: 1;
    }

    .vs-tabs-position-left .vs-tabs--li {
        padding: 0;
    }

    .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 1rem;
    }

    .vx-card .vx-card__collapsible-content.vs-con-loading__container {
        height: 300px;
    }

    .vs-tabs-position-left .con-ul-tabs {
        width: 180px;
        height: 230px;
        overflow-y: scroll;
    }
}

.vs-popup--content {
    overflow: auto;
}

.tooltip {
    z-index: 99999 !important;
}

</style>
